import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ChangePasswordDialog({ onClose }) {
  const [f, setF] = useState({ old_password: "", new_password: "", confirm: "" }); const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (f.new_password !== f.confirm) return toast.error("Konfirmasi password tidak sama");
    setBusy(true);
    try { await api.post("/auth/change-password", { old_password: f.old_password, new_password: f.new_password }); toast.success("Password berhasil diganti"); onClose(); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><KeyRound size={18} /> Ganti Password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label htmlFor="cp-old">Password lama</Label><Input id="cp-old" data-testid="cp-old" type="password" value={f.old_password} onChange={set("old_password")} autoComplete="current-password" /></div>
          <div><Label htmlFor="cp-new">Password baru (min. 6 karakter)</Label><Input id="cp-new" data-testid="cp-new" type="password" value={f.new_password} onChange={set("new_password")} required autoComplete="new-password" /></div>
          <div><Label htmlFor="cp-confirm">Konfirmasi password baru</Label><Input id="cp-confirm" data-testid="cp-confirm" type="password" value={f.confirm} onChange={set("confirm")} required autoComplete="new-password" /></div>
          <div className="flex justify-end gap-2 pt-1"><Button type="button" variant="outline" onClick={onClose}>Batal</Button><Button type="submit" data-testid="cp-submit" disabled={busy}>Simpan</Button></div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
